import { useMutation, useQueryClient } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useSendKimMessage = (matterId?: string, subsetId?: string, threadId?: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async (message: string) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: { message },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/message`,
        fetchConfig,
      );
      if (!response.ok) {
        throw new Error('Sending Kim message failed');
      }
      return response.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.KimMessages, { threadId }]);
      },
    },
  );
};
